import actionTypes from '../../actions/actionTypes';

const initialState = {
    notificationList: {
        items: [],
        totalItems: 0,
    },
    fullNotificationList: {
        items: [],
        totalItems: 0,
    },
    tenantId: '',
    reportEngine: [],
    /* Report Engine Data Format
        {
            reportName: '',
            organizationUuid: '',
            fields: [{
                fieldKey: '',
                fieldName: '',
                order: 1,
                calculateAmount: false,
            }],
        }
    */
    timezoneList: [],
    errorView: { isError: false, errorInfo: '' },
};

const CommonReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_NOTIFICATION_LIST:
            return {
                ...state,
                notificationList: {
                    items: action.payload.notificationList,
                    totalItems: action.payload.total,
                },
            };
        case actionTypes.UPDATE_FULL_NOTIFICATION_LIST:
            return {
                ...state,
                fullNotificationList: {
                    items: action.payload.notificationList,
                    totalItems: action.payload.total,
                },
            };
        case actionTypes.SET_TENANT_ID:
            return {
                ...state,
                tenantId: action.payload.tenantId,
            };
        case actionTypes.SET_LOGO:
            return {
                ...state,
                documentLogo: action.payload.documentLogo,
            };
        case actionTypes.ADD_REPORT_ENGINE:
            return {
                ...state,
                reportEngine: [
                    ...state.reportEngine,
                    {
                        reportName: action.payload.reportName,
                        fields: action.payload.fields,
                        organizationUuid: action.payload.organizationUuid,
                    },
                ],
            };
        case actionTypes.UPDATE_REPORT_ENGINE:
            return {
                ...state,
                reportEngine: state.reportEngine.map(data => {
                    if (
                        data.reportName === action.payload.prevReportName &&
                        data.organizationUuid === action.payload.organizationUuid
                    ) {
                        return {
                            reportName: action.payload.prevReportName,
                            fields: action.payload.fields,
                            organizationUuid: action.payload.organizationUuid,
                        };
                    }
                    return data;
                }),
            };
        case actionTypes.DELETE_REPORT_ENGINE:
            return {
                ...state,
                reportEngine: state.reportEngine.filter(
                    report =>
                        report.organizationUuid !== action.payload.organizationUuid &&
                        report.reportName !== action.payload.reportName
                ),
            };
        case actionTypes.GET_TIMEZONE_LIST:
            return {
                ...state,
                timezoneList: action.payload.timezoneList,
            };
        case actionTypes.SET_PAGE_ERROR:
            return {
                ...state,
                errorView: { isError: action.payload.isError, errorInfo: action.payload.errorInfo },
            };
        default:
            return state;
    }
};

export default CommonReducer;
